































import { computed, defineComponent } from '@vue/composition-api';

import ConnectionLine from '../../components/connectionline';
import { useWorkFlow } from '../../composables';
import { getEdgeZIndex } from '../../utils';
import { EdgeMarkerType, MarkerProps, MarkerType } from '../../types';

import { getMarkerId } from '../../utils';

import WorkflowEdgeWrapper from '../../components/edge/WorkflowEdgeWrapper.vue';
import MarkerDefinitions from './MarkerDefinitions.vue';
import MarkerSymbols from './MarkerSymbols.vue';

export default defineComponent({
  name: 'MarkerDefinitions',
  components: {
    ConnectionLine,
    MarkerDefinitions,
    MarkerSymbols,
    WorkflowEdgeWrapper
  },
  setup() {
    const {
      id: workFlowId,
      connectionLineOptions,
      findNode,
      defaultMarkerColor,
      edges,
      getEdges,
      elevateEdgesOnSelect
    } = useWorkFlow();

    const markers = computed(() => {
      const ids: Set<string> = new Set();
      const markers: MarkerProps[] = [];
      const createMarkers = (marker?: EdgeMarkerType) => {
        if (marker) {
          const markerId = getMarkerId(marker, workFlowId);
          if (!ids.has(markerId)) {
            if (typeof marker === 'object') {
              markers.push({
                ...marker,
                id: markerId,
                color: marker.color || defaultMarkerColor.value
              });
            } else {
              markers.push({
                id: markerId,
                color: defaultMarkerColor.value,
                type: marker as MarkerType
              });
            }
            ids.add(markerId);
          }
        }
      };
      for (const marker of [
        connectionLineOptions.value.markerEnd,
        connectionLineOptions.value.markerStart
      ]) {
        createMarkers(marker);
      }
      for (const edge of edges.value) {
        for (const marker of [edge.markerStart, edge.markerEnd]) {
          createMarkers(marker);
        }
      }
      return markers.sort((a, b) => a.id.localeCompare(b.id));
    });

    return {
      getEdgeZIndex,
      getEdges,
      findNode,
      elevateEdgesOnSelect,

      markers
    };
  }
});
